

import React, { useEffect, useRef, useState } from 'react';
import styles from "../../assets/scss/Invoice/MyInvoice.module.scss";
import { FaEdit, FaEllipsisV, FaEye } from 'react-icons/fa';
import Pagination from '../../Components/Common/Pagination';
import { useNavigate } from 'react-router-dom';
import { useCancelInvoiceMyMutation, useGetMyInvoicesselfQuery, useGetMyVendorsQuery, useUpdateInvoiceStatusByOwnerMutation } from '../../slices/admin/admin';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import DeleteConfirmModal from '../../Components/Common/DeleteConfirmModal';
import { toast } from 'react-toastify';
import { getUserInfo } from '../../utils/user.util';
import { capitalize } from '../../utils/capitalize';

const MyInvoice = () => {
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState('');
    const [status, setStatus] = useState('');
    const [storeId, setStoreId] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

    const dropdownRef = useRef(null);

    const user = getUserInfo();



    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(`.${styles.dropdownWrapper}`)) {
                setDropdownOpen(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);
    const [cancelInvoice] = useCancelInvoiceMyMutation();
    const [updateStatus] = useUpdateInvoiceStatusByOwnerMutation();

    const hasMyInvoiceFullAccess = user?.type === 'farmer' &&
        user?.roles?.some(role =>
            role?.permissions?.some(
                p =>
                    p?.functionality === 'myinvoice' &&
                    p?.permissionType === 'fullaccess' &&
                    p?.isActive
            )
        );

    const handleConfirmCancel = async () => {
        try {
            await cancelInvoice(selectedInvoiceId).unwrap();
            toast.success("Invoice cancelled successfully!");
            setIsModalOpen(false);
            setSelectedInvoiceId(null);
            setDropdownOpen(null);
        } catch (error) {
            console.error("Failed to cancel invoice:", error);
            toast.error("Failed to cancel the invoice.");
        }
    };
    const offset = currentPage;

    const { data, isLoading, refetch } = useGetMyInvoicesselfQuery({
        offset,
        limit,
        status,
        invoiceStore: storeId,
        search,
        fromDate: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : undefined,
        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : undefined,
    });

    console.log(data, "data777");



    useEffect(() => {
        setCurrentPage(1);
    }, [storeId, search, fromDate, toDate, status]);

    useEffect(() => {
        const shouldRefetch = localStorage.getItem('myInvoiceNeedsRefetch');
        if (shouldRefetch === 'true') {
            refetch();
            localStorage.removeItem('myInvoiceNeedsRefetch');
        }
    }, []);




    const invoices = data?.myInvoices || [];
    const totalPages = Math.ceil((data?.total || 0) / limit);

    const { data: vendorData } = useGetMyVendorsQuery();
    const stores = vendorData?.stores || [];

    const handleClose = () => {
        navigate('/dashboard/Invoicetable');
    };

    return (
        <div>
            {/* {!hasMyInvoiceFullAccess && (
                <>
                    <div className={styles.headers}>
                        <h2 className={styles.tittle}>My Invoice</h2>
                        <span className={styles.closeIcon} onClick={handleClose}>✕</span>
                    </div>
                </>
            )} */}


            <div className={styles.orderContainer}>
                <div className={styles.header}>
                    <div className={styles.filterRow}>
                        <div className={styles.filterRows}>
                            <input
                                type="text"
                                placeholder="Search here..."
                                className={styles.searchInput}
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />

                            <select
                                className={styles.inputs}
                                value={storeId}
                                onChange={(e) => setStoreId(e.target.value)}
                            >
                                <option value="">Store Name</option>
                                {stores.map((store) => (
                                    <option key={store._id} value={store._id}>
                                        {store.storeName}
                                    </option>
                                ))}
                            </select>

                            <select
                                className={styles.inputs}
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                            >
                                <option value="">Invoice Status</option>
                                <option value="pending">Pending</option>
                                <option value="created">Created</option>
                                <option value="accepted">Accepted</option>
                            </select>

                            <DatePicker
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd.MM.yyyy"
                                placeholderText="From Date"
                                maxDate={new Date()}
                                isClearable
                                className={styles.inputss}
                            />

                            <DatePicker
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd.MM.yyyy"
                                placeholderText="To Date"
                                maxDate={new Date()}
                                isClearable
                                className={styles.inputss}
                            />

                            <button
                                className={styles.clearBtn}
                                onClick={() => {
                                    setSearch('');
                                    setStoreId('');
                                    setStatus('');
                                    setFromDate(null);
                                    setToDate(null);
                                }}
                            >
                                Clear All
                            </button>

                            {(hasMyInvoiceFullAccess || user?.type === "retailowner" || user?.type === "customer") && (
                                <button
                                    className={styles.addBtn}
                                    onClick={() => navigate('/dashboard/CreateInvoice')}
                                >
                                    + Create Invoice
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className={styles.tableWrapper}>
                    <table>
                        <thead>
                            <tr>
                                <th>Invoice ID</th>
                                <th>Invoice Placed To</th>
                                <th>Invoice Date</th>
                                <th>Invoice Status</th>
                                <th>Transport Status</th>
                                <th>TransportAmount</th>
                                <th>Sale Commission</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="9" className={styles.noData}>Loading...</td>
                                </tr>
                            ) : invoices.length > 0 ? (
                                invoices.map((inv) => (
                                    <tr key={inv._id}>
                                        <td className="notranslate">{inv.invoiceNumber}</td>
                                        <td>{inv.invoiceStore?.storeName ? capitalize(inv.invoiceStore.storeName) : '-'}</td>
                                        <td>{new Date(inv.createdAt).toLocaleDateString()}</td>
                                        <td>
                                            <span className={`${styles.status} ${
                                                inv.status?.toLowerCase() === "approved" || inv.status?.toLowerCase() === "completed" || inv.status?.toLowerCase() === "dispatched"
                                                ? styles.statusApproved
                                                : inv.status?.toLowerCase() === "pending" || inv.status?.toLowerCase() === "created"
                                                ? styles.statusPending
                                                : inv.status?.toLowerCase() === "readyforpickup" || inv.status?.toLowerCase() === "readyforbilling"
                                                ? styles.statusWarning
                                                : inv.status?.toLowerCase() === "rejected" || inv.status?.toLowerCase() === "cancelled"
                                                ? styles.statusRejected
                                                : styles.statusDefault
                                            }`}>
                                                {inv.status ? capitalize(inv.status) : '-'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className={`${styles.status} ${
                                                inv.logisticStatus?.toLowerCase() === "approved" || inv.logisticStatus?.toLowerCase() === "completed" || inv.logisticStatus?.toLowerCase() === "dispatched" || inv.logisticStatus?.toLowerCase() === "delivered"
                                                ? styles.statusApproved
                                                : inv.logisticStatus?.toLowerCase() === "pending" || inv.logisticStatus?.toLowerCase() === "ontheway"
                                                ? styles.statusPending
                                                : inv.logisticStatus?.toLowerCase() === "readyforpickup" || inv.logisticStatus?.toLowerCase() === "readyforbilling"
                                                ? styles.statusWarning
                                                : inv.logisticStatus?.toLowerCase() === "rejected" || inv.logisticStatus?.toLowerCase() === "cancelled"
                                                ? styles.statusRejected
                                                : styles.statusDefault
                                            }`}>
                                                {inv.logisticStatus ? capitalize(inv.logisticStatus) : '-'}
                                            </span>
                                        </td>
                                        <td className="notranslate">₹{inv.amount}</td>
                                        <td>{inv.saleCommission ? capitalize(inv.saleCommission) : '-'}</td>
                                        <td>
                                            <div className={styles.actions}>
                                                <FaEye
                                                    className={styles.icon}
                                                    onClick={() =>
                                                        navigate("/dashboard/ViewMyInvoice", {
                                                            state: { invoiceId: inv._id, viewOnly: true },
                                                        })
                                                    }
                                                />
                                                {!(inv.status?.toLowerCase() === "dispatched" || inv.status?.toLowerCase() === "approved") && (
                                                    <FaEdit
                                                        className={styles.icon}
                                                        onClick={() =>
                                                            navigate("/dashboard/UpdateMyInvoice", {
                                                                state: { invoiceId: inv._id, viewOnly: false },
                                                            })
                                                        }
                                                    />
                                                )}

                                                {/* Show action buttons directly — no 3-dot menu */}
                                                {inv.status !== "cancelled" && inv.status === "pending" && (
                                                    <div className={styles.actionWrapper}>


                                                        <button
                                                            className={styles.approveButton}
                                                            onClick={async () => {
                                                                try {
                                                                    await updateStatus(inv._id).unwrap();
                                                                    toast.success("Invoice status successfully updated");
                                                                } catch (err) {
                                                                    toast.error("Failed to update invoice status.");
                                                                    console.error(err);
                                                                }
                                                            }}
                                                        >
                                                            Ready for pick up
                                                        </button>
                                                        <button
                                                            className={styles.cancelButton}
                                                            onClick={() => {
                                                                setSelectedInvoiceId(inv._id);
                                                                setIsModalOpen(true);
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                )}


                                                {/* 3 dot dropdown menu - correct code commented out started
                                                <div className={styles.dropdownWrapper} ref={dropdownRef}>
                                                    <button
                                                        className={styles.dropdownToggle}
                                                        onClick={() =>
                                                            setDropdownOpen((prev) => (prev === inv._id ? null : inv._id))
                                                        }
                                                    >
                                                        <FaEllipsisV className={styles.icon} />
                                                    </button>

                                                  
                                                    {inv.status !== 'cancelled' && dropdownOpen === inv._id && (
                                                        <div className={styles.dropdownMenu}>
                                                            {inv.status === 'pending' && (
                                                                <>
                                                                    <button
                                                                        className={styles.dropdownItem}
                                                                        onClick={() => {
                                                                            setSelectedInvoiceId(inv._id);
                                                                            setIsModalOpen(true);
                                                                        }}
                                                                    >
                                                                        Cancel Invoice
                                                                    </button>

                                                                    <button
                                                                        className={styles.dropdownItem}
                                                                        onClick={async () => {
                                                                            try {
                                                                                await updateStatus(inv._id).unwrap();
                                                                                toast.success("Invoice status successfully updated");
                                                                                setDropdownOpen(null);
                                                                            } catch (err) {
                                                                                toast.error("Failed to update invoice status.");
                                                                                console.error(err);
                                                                            }
                                                                        }}
                                                                    >
                                                                        Ready to Pick Up
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}

                                                </div>
                                                
                                                3 dot dropdown menu - correct code commented out end */}


                                            </div>
                                        </td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className={styles.noData}>No Invoices Found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className={styles.paginationWrapper}>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                    <select
                        className={styles.inputsbtn}
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={10}>10 rows</option>
                        <option value={25}>25 rows</option>
                        <option value={50}>50 rows</option>
                    </select>
                </div>
                <DeleteConfirmModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onConfirm={handleConfirmCancel}
                />
            </div>


        </div>
    );
};

export default MyInvoice;

